mainApp.component('macAddressAuthentication', {
    templateUrl: '/public/components/mac-address-authentication.component.html',
     bindings: {
        model: '=',
        changesListener: '&'
     },
     controller: ['$scope', "LocationService", function($scope, LocationService)
     {
         var ctrl = this;

         ctrl.$onInit = function(){
             ctrl.hasChanges = false;
             loadAllocatedIps()
             if (!ctrl.model.retriesTimeOut){
                ctrl.model.retriesTimeOut = 3;
             }
             if (!ctrl.model.retriesNum){
                ctrl.model.retriesNum = 1;
             }
             if (!ctrl.model.timeTrafficAllowedForHostInterval){
                ctrl.model.timeTrafficAllowedForHost = 16;
                ctrl.model.timeTrafficAllowedForHostInterval = "HOURS";
             }
             if (!ctrl.model.timeTrafficRejectedForHostInterval){
                ctrl.model.timeTrafficRejectedForHost = 10;
                ctrl.model.timeTrafficRejectedForHostInterval = "MINUTES";
             }
             reload();
         }

         $scope.enablePwChanage = function () {
            $scope.showEditPW = true;
         }

         $scope.periodTypes = [{display:"Minutes", value:"MINUTES"}, {display:"Hours", value:"HOURS"}, {display:"Days", value:"DAYS"}, {display:"Weeks", value:"WEEKS"}, {display:"Months", value:"MONTHS"}];

         ctrl.$doCheck = function() {
             if (!ctrl.changesListener)
                 return;

             const isChangedNow = !angular.equals(ctrl.model, ctrl.original);

             //check if listener was already called and updates about having changes
             if (ctrl.hasChanges === isChangedNow)
                 return;

             ctrl.hasChanges = isChangedNow;
             ctrl.changesListener({
                 isDirty: ctrl.hasChanges,
                 componentName: 'macAddressAuthentication'
             });
         }

         function loadAllocatedIps(onSuccess) {
             if($scope.$parent.account){
                 store.fetch({
                     path: "/fetchAllocatedIps?accountId=" + $scope.$parent.account.id,
                     queryParams: {
                         accountId: $scope.$parent.account.id
                     },
                     success: function(data) {
                         enrichAllocatedIps(data);
                         var emptySlot = { ip: "", displayName: ""};
                         $scope.primaryIpForwardingOptions = [];
                         $scope.primaryIpForwardingOptions.push(emptySlot);
                         $scope.secondaryIpForwardingOptions =[];
                         $scope.secondaryIpForwardingOptions.push(emptySlot);

                         data.forEach(function (allocatedIp) {
                             $scope.primaryIpForwardingOptions.push(allocatedIp);
                             $scope.secondaryIpForwardingOptions.push(allocatedIp);
                         });
                         if(onSuccess){
                             onSuccess();
                         }
                     }
                 });
             }
         }

          function enrichAllocatedIps(items) {
             if(items){
                 items.forEach(function (item) {
                     enrichSingleAllocatedIp(item);
                 });
             }
         }

           $scope.$on('modelReloadedEvent', function (event, data) {
                reload();
           });

           function reload() {
                ctrl.original = angular.copy(ctrl.model);
           }

         /**
          * enrichment of the location on a single allocated ip
          * @param allocatedIp
          */
         function enrichSingleAllocatedIp(allocatedIp) {
             if(!allocatedIp.displayName){
                 var locationName = LocationService.getPopLocationViaLocationId($scope.$parent.account.id, allocatedIp.locationId);
                 allocatedIp.displayName = locationName ? (locationName.name + ' - ' + allocatedIp.ip): ('Allocated IP - ' + allocatedIp.ip);
             }
         }
     }]
});